
import { FdmPlugin, FdmPluginInterface } from '../plugins';

const tzlookup = require("tz-lookup");

export class TimeController extends FdmPlugin implements FdmPluginInterface {

    static meta = {

        label: 'PLUGINS.TIME_CONTROLLER.LABEL',
        name: 'time-controller',
        translator: 'PLUGINS.TIME_CONTROLLER',
        tooltip: 'PLUGINS.TIME_CONTROLLER.TOOLTIP',
        shortcut: false,
        icon: 'clock',

        category: FdmPlugin.category.generic,

        types: [ FdmPlugin.types.cameraController ],
        cardinality: FdmPlugin.cardinality.one,
    };

    // mapService:any = null;

    init() {

        // this.mapService = this.services.mapService;

        // recheck every 2 seconds to recalibrate with current camera position
        this.pulseSeconds = 3;

        // start pulsing
        this.startPulse();

        // first time pulse
        this.pulse();
    }

    end() {
        // console.log('ending time!');
        this.stopPulse();
    }

    pulse() {
        this.refresh();
    }

    refresh() {

        // TODO : rewrite this to use a cache instead of doing this work every two seconds; 
        //        only update stuff if the camera position has moved more than X/Y

        if ( this.services.mapService && this.services.mapService.cameralocation ) {

            this.services.uiManager.sidebarHeightAdjust();

            if ( ! this.services.mapService.cameralocation.timeZone ) {
                // start with the user's default timezone
                this.services.mapService.cameralocation.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
    
            if ( this.services.mapService.cameralocation.latitude && this.services.mapService.cameralocation.longitude ) {
                let check = tzlookup( this.services.mapService.cameralocation.latitude, this.services.mapService.cameralocation.longitude );
                if ( check ) {
                    this.services.mapService.cameralocation.timeZone = check;
                }
            }    

            // start off with now
            this.services.mapService.cameralocation.dateClient = new Date();

            // find the time of the timezone we're looking at
            this.services.mapService.cameralocation.dateCamera = new Date( this.services.mapService.cameralocation.dateClient.toLocaleString("en-US", { timeZone: this.services.mapService.cameralocation.timeZone }));

            // time where the camera is viewing
            let hstr = this.services.mapService.cameralocation.dateCamera.toTimeString(); 
            this.services.mapService.cameralocation.timeLabel = hstr.substr(0,hstr.indexOf(' ') - 3);

            // console.log('checking time ...',this.services.mapService.cameralocation, hstr);

        }
    }


}
